import { createAction, props } from '@ngrx/store';
import { Product } from '@zayan-erp/home-building';

export const setSelectedProductListId = createAction(
  '[Product] Set Selected Product List Id',
  props<{ productListId: string | null }>()
);
export const setSelectedCategoryId = createAction(
  '[Product] Set Selected Category Id',
  props<{ categoryId: string | null }>()
);
export const setSelectedSubcategoryId = createAction(
  '[Product] Set Selected Subcategory Id',
  props<{ subcategoryId: string | null }>()
);
export const setSelectedProduct = createAction('[Product] Set Selected Product', props<{ product: Product | null }>());
